import { Edit } from '@mui/icons-material';
import {
  Checkbox,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';

import { TopicsScores } from '@/domain/impact-calculate/entities/calculate.entity';
import { ParityBarInline } from '@/ui/components/parity-bar/ParityBarInline';
import { ScoreTag } from '@/ui/components/score/ScoreTag';
import { ColorsRaw } from '@/ui/theme/colors-raw';
import { ColorsScore } from '@/ui/theme/colors-score';
import { getColorForScore } from '@/ui/utils/get-color-for-score';

import { formatMonthName, getScoreForMonth } from '../utils';

export function MonthHeader({
  monthDate,
  scoresByMonth,
  onClickEditMonth,
  isSelecting,
  allSelectedInMonth,
  someSelectedInMonth,
  onToggleAllForMonth,
}: {
  monthDate: string;
  scoresByMonth: Record<string, TopicsScores>;
  onClickEditMonth: (monthDate: string) => void;
  isSelecting: boolean;
  allSelectedInMonth: boolean;
  someSelectedInMonth: boolean;
  onToggleAllForMonth: () => void;
}) {
  const monthName = formatMonthName(monthDate);
  const scores = getScoreForMonth(scoresByMonth, monthDate);

  return (
    <>
      <Stack
        onClick={isSelecting ? onToggleAllForMonth : undefined}
        sx={{
          mx: 2,
          my: 2,
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: 2,
          cursor: isSelecting ? 'pointer' : undefined,
        }}
      >
        <Stack sx={{ flexDirection: 'row', alignItems: 'center', gap: 1 }}>
          {isSelecting && (
            <Checkbox
              checked={allSelectedInMonth}
              indeterminate={someSelectedInMonth && !allSelectedInMonth}
              onChange={onToggleAllForMonth}
              onClick={(e) => e.stopPropagation()}
            />
          )}
          <Typography
            sx={{
              fontSize: '2.25rem',
              fontWeight: 800,
              color: ColorsRaw.basic.Cream,
              textTransform: 'capitalize',
            }}
          >
            {monthName}
          </Typography>
        </Stack>
        <Stack
          sx={{
            alignItems: 'start',
            flexDirection: 'row',
            gap: 2,
          }}
        >
          <ParityBarInline
            women={parseInt(scores.totalWomen) || 0}
            men={parseInt(scores.totalMen) || 0}
            other={parseInt(scores.totalOther) || 0}
          />
          {/* <Divider orientation="vertical" /> */}
          <ScoreTag value={scores.co2} colors={ColorsScore.none} topic="co2" />
          <ScoreTag
            value={scores.env}
            colors={getColorForScore(scores.env)}
            topic="env"
          />
          <IconButton
            onClick={() => onClickEditMonth(monthDate)}
            disabled={isSelecting}
          >
            <Edit />
          </IconButton>
        </Stack>
      </Stack>
      <Divider />
    </>
  );
}
